import React from "react";
import ExcelImportPage from "./ExcelImportPage";

const ImportCheck = () => (
  <ExcelImportPage
    title="درون‌ریزی چک از اکسل"
    endpoint="/import-check/"
    description="فایل چک‌ها را انتخاب کنید. پس از بارگذاری، نتیجه در همین صفحه نمایش داده می‌شود."
  />
);

export default ImportCheck;
